import React, { useEffect, useState } from "react";
// import dynamic from 'next/dynamic';
// const SvgFinde = dynamic(() => import('@/icon/SvgFinde').then(module => module.SvgFinde));

export declare type InputProps = {
    data: any,
    columns: any,
    children?: JSX.Element | JSX.Element[],
}


const CTable = ({ data, columns, children }: InputProps) => {
    const [listData, setListData] = useState<any>([]);

    useEffect(() => {
        if (data) {
            setListData(data)
        }
    }, [data]);

    return (
        <div className="Ctable-parent">
            <table className="Ctable">
                <tr className="Ctable-head">
                    {columns.map((item: any, index: number) =>
                        <>
                            {item?.isActive != false &&
                                <th key={index} >
                                    <span>{item.title}</span>
                                </th>
                            }
                        </>
                    )}
                </tr>
                {listData.map((item: any, index: number) =>
                    <tr key={index} className="Ctable-row" >
                        {columns.map((items: any, indexT: number) =>
                            <>
                               {items?.isActive != false &&
                                    <td key={indexT}>
                                        {item[items.dataIndex]}
                                        {item[items.dataIndex] == undefined && items.render(item)}
                                    </td>
                                }
                            </>
                        )}
                    </tr>
                )}
            </table>
            {listData.length == 0 &&
                <div className=" w-full h-[200px] flex flex-col justify-center items-center  shadow">
                    {/* <SvgFinde className="w-[60px] fill-dayan-gray-100" /> */}
                    <span className="text-sm mt-6">هیچ داده ای برای نمایش وجود ندارد</span>
                </div>
            }
            {children && listData.length > 0 &&
                <div className="Ctable-counter">
                    {children}
                </div>
            }
        </div>
    )
}


export default CTable;